"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SyncConfigDialog',
  props: {
    // 与父组件的 :visible.sync 对齐
    visible: {
      type: Boolean,
      default: false
    },
    // 父组件可传入配送模板列表：[{ id, name }]
    deliveryTemplates: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 父组件传入地区级联数据
    regionOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 由父组件传入的初始化数据，用于回显
    initialData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this = this;
    return {
      innerVisible: this.visible,
      submitting: false,
      form: {
        region: [],
        deliveryTemplateId: undefined,
        startFee: null,
        packageFee: null,
        maxCookMinutes: undefined,
        bizStartTime: '',
        bizEndTime: ''
      },
      rules: {
        region: [{
          type: 'array',
          required: false,
          message: '请选择店铺所在地区',
          trigger: 'change'
        }],
        deliveryTemplateId: [{
          required: false,
          message: '请选择配送模板',
          trigger: 'change'
        }],
        startFee: [{
          validator: function validator(rule, value, cb) {
            if (value === null || value === undefined || value === '') return cb();
            return value >= 0 ? cb() : cb(new Error('起送费不能小于0'));
          },
          trigger: 'change'
        }],
        packageFee: [{
          validator: function validator(rule, value, cb) {
            if (value === null || value === undefined || value === '') return cb();
            return value >= 0 ? cb() : cb(new Error('打包费不能小于0'));
          },
          trigger: 'change'
        }],
        maxCookMinutes: [{
          required: false,
          message: '请输入最大出餐时间',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, cb) {
            if (!value || value === '') return cb();
            return Number.isInteger(Number(value)) && Number(value) > 0 ? cb() : cb(new Error('请输入正整数分钟'));
          },
          trigger: 'blur'
        }],
        bizStartTime: [{
          required: false,
          message: '请选择营业开始时间',
          trigger: 'change'
        }],
        bizEndTime: [{
          required: false,
          message: '请选择营业结束时间',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, cb) {
            if (!value || !_this.form.bizStartTime) return cb();
            cb(value > _this.form.bizStartTime ? undefined : new Error('结束时间需大于开始时间'));
          },
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    visible: function visible(val) {
      this.innerVisible = val;
    },
    innerVisible: function innerVisible(val) {
      // 同步回父组件
      this.$emit('update:visible', val);
      if (val) {
        this.fillFormFromInitial();
      }
    }
  },
  computed: {
    regionOptionsProp: function regionOptionsProp() {
      return this.regionOptions || [];
    }
  },
  methods: {
    fillFormFromInitial: function fillFormFromInitial() {
      var d = this.initialData || {};
      // regionId: '22,2058,2060'
      if (d.regionId) {
        this.form.region = String(d.regionId).split(',').map(function (v) {
          return Number(v);
        }).filter(function (v) {
          return !Number.isNaN(v);
        });
      } else {
        this.form.region = [];
      }
      this.form.deliveryTemplateId = d.deliveryTemplateId !== undefined && d.deliveryTemplateId !== null ? d.deliveryTemplateId : undefined;
      this.form.startFee = d.deliveryStartFee !== undefined && d.deliveryStartFee !== null ? d.deliveryStartFee : null;
      this.form.packageFee = d.packingFee !== undefined && d.packingFee !== null ? d.packingFee : null;
      this.form.maxCookMinutes = d.maxMealTime !== undefined && d.maxMealTime !== null ? d.maxMealTime : undefined;
      this.form.bizStartTime = d.beginTime || '';
      this.form.bizEndTime = d.endTime || '';
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this2.submitting = true;
        try {
          var payload = _this2.normalizePayload();
          // 交给父组件保存
          _this2.$emit('sync-completed', payload);
          _this2.innerVisible = false;
        } finally {
          _this2.submitting = false;
        }
      });
    },
    normalizePayload: function normalizePayload() {
      return {
        // 后端需要 regionId 为逗号分隔的三级ID
        regionId: this.form.region && this.form.region.length > 0 ? this.form.region.join(',') : '',
        deliveryTemplateId: this.form.deliveryTemplateId || null,
        deliveryStartFee: this.form.startFee !== null && this.form.startFee !== undefined && this.form.startFee !== '' ? Number(this.form.startFee) : null,
        packingFee: this.form.packageFee !== null && this.form.packageFee !== undefined && this.form.packageFee !== '' ? Number(this.form.packageFee) : null,
        maxMealTime: this.form.maxCookMinutes !== null && this.form.maxCookMinutes !== undefined && this.form.maxCookMinutes !== '' ? Number(this.form.maxCookMinutes) : null,
        beginTime: this.form.bizStartTime || '',
        endTime: this.form.bizEndTime || ''
      };
    },
    handleClose: function handleClose() {
      this.innerVisible = false;
    }
  }
};